import React from 'react';

const stats = [
    { value: '15+', label: 'Training Sessions' },
    { value: '5+', label: 'CTF Events' },
    { value: '700+', label: 'Students Trained' },
    { value: '10+', label: 'Corporate Clients' },
];

const About = () => {
    return (
        <section id="about" className="bg-[#121212] text-white px-6 md:px-16 py-20">
            <div className="flex flex-col md:flex-row items-start gap-10">
                {/* Left Side */}
                <div className="flex-1" data-aos="fade-right" data-aos-duration="1000">
                    <h2 className="text-3xl font-bold mb-4">
                        About <span className="text-red-500">SiberLab ID</span>
                    </h2>
                    <p className="text-gray-400 mb-4">
                        SiberLab ID was founded with a mission to strengthen Indonesia's cybersecurity posture through education, training, and professional services.
                    </p>
                    <p className="text-gray-400 mb-4">
                        We believe that cybersecurity knowledge should be accessible to all, which is why we've created Akademi Siber — a platform that delivers high-quality cybersecurity education in Bahasa Indonesia at student-friendly prices.
                    </p>
                    <p className="text-gray-400 mb-6">
                        Our team consists of experienced cybersecurity professionals who have worked with organizations of all sizes to secure their digital assets and train their teams.
                    </p>
                    <button className="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2 rounded">
                        Contact Us
                    </button>
                </div>

                {/* Right Side - Stats */}
                <div className="flex-1 grid grid-cols-2 gap-4" data-aos="fade-left" data-aos-duration="1000">
                    {stats.map((stat, idx) => (
                        <div key={idx} className="bg-[#1a1a1a] p-6 rounded-lg shadow-lg text-center border border-gray-700">
                            <h3 className="text-2xl font-bold text-red-500">{stat.value}</h3>
                            <p className="text-gray-300 mt-2">{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default About;
